import styled from "styled-components";
import { COLORS } from "../../../../../layout/theme";

export const Inner = styled.div`
	display: flex;
	width: 100%;
	gap: 20px;
	flex: 1;
`;

export const DataContainer = styled.div`
	display: flex;
	flex: 1 1 50%;
	flex-direction: column;
	gap: 10px;
	background-color: ${COLORS.White};
	padding: 40px;
	border-radius: 10px;
`;
